import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return o(), l("svg", n, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M7.988 2a4.234 4.234 0 1 0 0 8.467 4.234 4.234 0 0 0 0-8.467m.394 9.995c-.275.005-.489.005-.764 0-1.082-.02-2.761-.053-4.125 1.002C1.906 14.224 1 16.645 1 21a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1c0-4.355-.906-6.776-2.493-8.004-1.364-1.054-3.043-1.022-4.125-1.001m12.393.58C22.195 13.584 23 15.564 23 19a1 1 0 0 1-1 1h-3.98A1.02 1.02 0 0 1 17 18.98c0-.908-.012-3.184-1.779-5.54-.465-.62-.095-1.535.7-1.626.325-.037.647-.037.97-.037q.2 0 .4-.003c.852-.017 2.292-.045 3.484.8M16.99 3a3.515 3.515 0 1 0 0 7.03 3.515 3.515 0 0 0 0-7.03",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: t };
export {
  i as default,
  t as render
};
//# sourceMappingURL=ic_codriver_filled-BqHr3H8E.js.map
